import { render, staticRenderFns } from "./_Keyword.vue?vue&type=template&id=4eed3ece&scoped=true&"
import script from "./_Keyword.vue?vue&type=script&lang=js&"
export * from "./_Keyword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eed3ece",
  null
  
)

export default component.exports